import React, { ReactElement, useEffect } from 'react';

import { Auth } from '@justgiving/auth';
import { Dispatch } from 'redux';
import { IAppState } from '../../types/state';
import Loading from '@justgiving/loading/es/Loading';
import { connect } from 'react-redux';
import { getCaptainId } from '../../selectors/apiSelectors';
import { setErrorStatus } from '../../actions/actionCreators/apiActions';
import { withAuth } from '@justgiving/auth-react';

type PageOwnerOnlyProps = {
  children: ReactElement;
  auth: Auth;
  pageOwnerId: string;
  setErrorStatus: typeof setErrorStatus;
};

const PageOwnerOnly: React.FC<PageOwnerOnlyProps> = ({
  children,
  auth,
  pageOwnerId,
  setErrorStatus,
}) => {
  const userId = auth.getAccessToken()?.guid;

  useEffect(() => {
    if (userId !== pageOwnerId) {
      setErrorStatus('403');
    }
  }, [userId, pageOwnerId, setErrorStatus]);

  if (userId !== pageOwnerId) {
    return <Loading />;
  }

  return children;
};

const mapStateToProps = (
  state: IAppState,
): Pick<PageOwnerOnlyProps, 'pageOwnerId'> => ({
  pageOwnerId: getCaptainId(state),
});

function mapDispatchToProps(
  dispatch: Dispatch,
): Pick<PageOwnerOnlyProps, 'setErrorStatus'> {
  return {
    setErrorStatus: (status: string) => dispatch(setErrorStatus(status)),
  };
}

export default withAuth(
  connect(mapStateToProps, mapDispatchToProps)(PageOwnerOnly),
);
